// @flow
import React, {
  lazy,
  Suspense,
  useState,
  useRef,
  useEffect,
  useContext
} from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import './styles.scss'
import config from 'config'
import ClubLogo from '../clubLogo'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
// import PastMatches from 'components/pastMatches'
import { Link, useParams, useHistory } from 'react-router-dom'
import { LocaleContext } from '../../contexts/locale'
import germanMessages from './locales/de.yml'
import frenchMessages from './locales/fr.yml'
import { RankingTable } from 'components/rankingTable'
import { CopyToClipboardUrl } from 'components/copyToClipboardUrl'

// let teamExample: any = require('./team-example.json')
// console.log(teamExample)

const ClubSearch = lazy(() => import('components/clubSearch'))

const LANGPARAM = {
  fr: 'fr_FR',
  de: 'de_DE'
}

// Translated strings, stored in YAML files
const MESSAGES = {
  de: germanMessages,
  fr: frenchMessages
}

interface Props {
  match: any
  handleClubSelection: (number) => void
}

export const Article = ({ match, handleClubSelection }: Props) => {
  const [matchData, setMatchData] = useState(null)
  const [ranking, setRanking] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const params = useParams()
  const locale = useContext(LocaleContext)
  const t = MESSAGES[locale]
  const history = useHistory()

  const handleError = (error: Error) => {
    setErrorMessage('Bis jetzt gibt es keinen Matchbericht zu diesem Team.')
    console.group('Fetch Article')
    console.warn('Article could not be loaded')
    console.warn(error)
    console.groupEnd()
  }

  const getLeagueUrl = leagueName => {
    if (leagueName) {
      return matchData.match_league_name.replace(/ /g, '')
    } else {
      return false
    }
  }

  const getLeagueAndGroup = value => {
    const out = value.match(/.*(\d+).*-.*(\d+)/i)
    return {
      league: parseInt(out[1]),
      group: parseInt(out[2])
    }
  }

  const getMatchText = (locale: 'de' | 'fr') => {
    let type = null
    let id = null

    if (params.matchId) {
      id = params.matchId
      type = 'match'
    } else if (params.teamId) {
      id = params.teamId
      type = 'team'
    }

    console.log('ID: ' + id + ' TYPE: ' + type)

    const BASE_URL = 'https://admin-nlg-foot.tamedia.ch'
    const API_ENDPOINT =
      type === 'match' ? '/api/gettext/matches/' : '/api/gettext/teams/'
    const LOCALE = 'lang=' + LANGPARAM[locale]
    debugger
    const url =
      BASE_URL +
      API_ENDPOINT +
      id +
      (type === 'team' ? '/latest?season=2022%2F2023&' + LOCALE : '?' + LOCALE + '&season=2022%2F2023')

    console.log(url)

    return window
      .fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        console.log(response)

        if (response.ok) {
          return response.json()
        }

        throw new Error(response.status + ': ' + response.message)
      })
  }

  // Get the data for the ranking table
  // /api/{asc}/league/{league_name}/ranking?asc=xx&league_name=xx&gender=1/2

  const getNewRanking = (association, leagueName, gender) => {
    const BASE_URL = 'https://admin-nlg-foot.tamedia.ch'
    const API_ENDPOINT =
      '/api/' +
      association +
      '/league/' +
      leagueName +
      '/ranking' +
      '?asc=' +
      association +
      '&league_name=' +
      leagueName +
      '&gender=' +
      gender +
      '&season=2022%2F2023'

    console.log(BASE_URL + API_ENDPOINT)

    return fetch(BASE_URL + API_ENDPOINT, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }).then(response => {
      if (response.ok) {
        return response.json().then(data => {
          return new Promise(resolve => resolve(data))
        })
      } else {
        throw new Error(response.status + ': ' + response.message)
      }
    })
  }

  const getRanking = (association, leagueName, matchDay) => {
    const BASE_URL = 'https://admin-nlg-foot.tamedia.ch'

    console.log(leagueName)

    const API_ENDPOINT_LAST_ROUND =
      '/api/' +
      association +
      '/league/' +
      leagueName +
      '/ranking/matchday/' +
      matchDay +
      '?season=2022%2F2023'
    const API_ENDPOINT_PREV_ROUND =
      '/api/' +
      association +
      '/league/' +
      leagueName +
      '/ranking/matchday/' +
      (matchDay - 1) +
      '?season=2022%2F2023'

    const URL_LAST_ROUND = BASE_URL + API_ENDPOINT_LAST_ROUND
    const URL_PREV_ROUND = BASE_URL + API_ENDPOINT_PREV_ROUND

    const promiseLast = window.fetch(URL_LAST_ROUND, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })

    const promisePrev = window.fetch(URL_PREV_ROUND, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })

    return Promise.all([promiseLast, promisePrev]).then(response => {
      const rankings = []

      response.map(r => {
        if (r.ok) {
          rankings.push(r.json())
        } else {
          throw new Error(r.status + ': ' + r.message)
        }
      })

      return Promise.all(rankings).then(r => {
        return new Promise(resolve => resolve([].concat(...r)))
      })
    })
  }

  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'input',
      event_label: `team:${params.teamId}`
    })

    getMatchText(locale)
      .then((data: { req_id: string; content: string }) => {
        console.log(data)
        let date = data.match_date.split(' ')
        date = date[0] + 'T' + date[1]
        console.log(date)
        setMatchData({
          articleText: data.rich_text,
          articleTitle: data.rich_title,
          articleSubtitle: data.subtitle,
          last_parsed_at: new Date(data.last_parsed_at),
          text_updated_at: new Date(data.text_updated_at),
          grp_match_day: data.grp_match_day,
          goals_home: data.match_goals_home,
          goals_away: data.match_goals_away,
          team_name_home: data.match_team_home_name,
          team_name_away: data.match_team_away_name,
          team_id_home: data.match_team_home_id,
          team_id_away: data.match_team_away_id,
          team_club_home: data.match_team_home_club_number,
          team_club_away: data.match_team_away_club_number,
          association_name: data.association_name,
          match_date: new Date(date),
          match_id: data.match_id,
          match_number: data.match_number,
          match_duration: data.match_duration,
          match_url: data.match_url,
          match_league_name: data.match_league_name,
          match_gender: data.match_team_home_gender,
          match_league_rank: data.match_team_home_league_rank,
          match_group_number: data.match_team_home_group_number,
          errorMessage: null,
          ...getLeagueAndGroup(data.match_league_name)
        })

        getNewRanking(
          data.association_name,
          data.match_league_name,
          data.match_gender
        )
          .then(data => {
            setRanking(data)
          })
          .catch(e => handleError(e))

        /* getRanking(
          data.association_name,
          data.match_league_name,
          data.grp_match_day
        ).then(data => {
          console.log('DATA')
          console.log(data)

          // get the most recent round day for each team
          const map = new Map()
          const ranking = []

          data.forEach(e => {
            const key = e.TeamName
            const collection = map.get(key)

            if (!collection) {
              map.set(key, [e])
            } else {
              collection.push(e)
            }
          })

          console.log('Ranking')
          console.log(map)

          map.forEach(e => {
            e.sort((a, b) => b.DaysPlayed - a.DaysPlayed)
            ranking.push(e[0])
          })

          setRanking(ranking.sort((a, b) => a.CurrentRank - b.CurrentRank))
          console.log(data)
        }) */

        console.log(getLeagueAndGroup(data.match_league_name))
      })
      .catch(e => handleError(e))
  }, [])

  return (
    <>
      {matchData && (
        <div
          className='scoreheader'
          style={{
            backgroundImage:
              'url(' +
              require('./scoreboard-background.svg') +
              '), linear-gradient(135deg,  #459873 0%, #49a2a7 100%)'
          }}
        >
          <div className='stripes' />
          <div
            className='lines'
            style={{
              backgroundImage: 'url(' + require('./scoreboard-line-a.png') + ')'
            }}
          />
          <div className='score-header-title'>
            <div className='sub'>
              {MESSAGES.de.gender[matchData.match_gender]} -{' '}
              {matchData.match_league_name.includes('interregional')
                ? 'Amateurliga - Gruppe ' + matchData.match_group_number
                : matchData.match_league_rank +
                  '. Liga - Gruppe ' +
                  matchData.match_group_number}
            </div>
            <div className='main'>
              {matchData.match_date &&
                matchData.match_date.toLocaleDateString(locale + '-CH', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
            </div>
            <div className='sub'>
              {MESSAGES.de.round} {matchData.grp_match_day}
            </div>
          </div>
          <div className='scoreheader-content ui container'>
            <div className='top'>
              <div className='duration'>{matchData.match_duration}'</div>
            </div>
            <div className='middle'>
              <div className='panel left'>
                <div className='team'>
                  <div className='team-content'>
                    <Link
                      to={config.routes.matchesHistory + matchData.team_id_home}
                      className=''
                    >
                      <ClubLogo clubNumber={matchData.team_club_home} />
                      <div className='team-name'>
                        {matchData.team_name_home}
                      </div>
                      <div className='team-link'>
                        Alle Spiele <i className='ui icon chevron right' />
                      </div>
                    </Link>
                  </div>
                </div>
                <div className='score'>{matchData.goals_home}</div>
              </div>
              <div className='vs'>
                <div />
                <div />
              </div>
              <div className='panel right'>
                <div className='team'>
                  <div className='team-content'>
                    <Link
                      to={config.routes.matchesHistory + matchData.team_id_away}
                      className=''
                    >
                      <ClubLogo clubNumber={matchData.team_club_away} />
                      <div className='team-name'>
                        {matchData.team_name_away}
                      </div>
                      <div className='team-link'>
                        Alle Spiele <i className='ui icon chevron right' />
                      </div>
                    </Link>
                  </div>
                </div>
                <div className='score'>{matchData.goals_away}</div>
              </div>
            </div>
            <div className='bottom'>
              <div className='panel left' />
              <div className='panel right' />
            </div>
            <Link
              className='teams-link'
              to={
                config.routes.matchesLeagueHistory +
                getLeagueUrl(matchData.match_league_name) +
                '/' +
                matchData.match_gender +
                '/' +
                matchData.association_name +
                '/' +
                matchData.grp_match_day
              }
            >
              <i className='ui icon calendar alternate outline' /> Alle Spiele
              der Runde {matchData.grp_match_day}{' '}
              <i className='ui icon chevron right' />
            </Link>
          </div>
        </div>
      )}

      {errorMessage && (
        <div className='ui text container'>
          <div className='ui icon message'>
            <i className='icon file alternate' />
            <div className='content'>
              <div className='header'>{errorMessage}</div>
              <p>Schauen Sie in ein paar Tagen wieder vorbei!</p>
            </div>
          </div>
        </div>
      )}

      <div className='ui container step article' style={{ zIndex: 10 }}>
        <div className='ui text container'>
          {matchData && (
            <div
              className='ui raised segment'
              style={{ paddingTop: '2em', borderTop: '1px solid #f1f2f3' }}
            >
              <>
                <h4 className='ui header'>
                  {ReactHtmlParser(matchData.articleTitle)}
                </h4>

                {ReactHtmlParser(matchData.articleText, {
                  transform: (node, index) => {
                    if (
                      node.type === 'tag' &&
                      node.name === 'p' &&
                      index === 1
                    ) {
                      return (
                        <div style={{ marginBottom: '1em' }}>
                          {convertNodeToElement(node, index)}
                          <FeedbackMessage
                            locale={locale}
                            mailTo='atm@tamedia.ch'
                          />
                        </div>
                      )
                    }
                  }
                })}

                <CopyToClipboardUrl
                  title='Beitrag teilen'
                  text='Teilen Sie diesen Matchbericht jetzt mit Freunden und Bekannten!'
                  url={`${
                    window.location.href.split('#')[0]
                  }#/article/for/match/${matchData.match_number}`}
                />

                <div className='ui divider' />
                <p>
                  <cite>
                    Tamedia, Text automatisch generiert<nbsp> </nbsp>
                    am{' '}
                    {matchData.text_updated_at.toLocaleDateString(
                      locale + '-CH',
                      {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      }
                    )}
                    {', um '}
                    {matchData.text_updated_at.toLocaleTimeString(
                      locale + '-CH',
                      {
                        hour: '2-digit',
                        minute: '2-digit'
                      }
                    )}
                    {' Uhr '} 
                    auf Basis von{' '}
                    <a href={matchData.match_url} target='blank'>
                      Daten des Schweizerischen Fussballverbands
                    </a>
                    .{' '}
                    {/* vom{' '}
                    {matchData.last_parsed_at.toLocaleDateString(
                      locale + '-CH',
                      {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      }
                    )}
                    {' um '}
                    {matchData.last_parsed_at.toLocaleTimeString(
                      locale + '-CH',
                      {
                        hour: '2-digit',
                        minute: '2-digit'
                      }
                    )}
                    {' Uhr.'} */}
                  </cite>
                </p>
              </>
            </div>
          )}

          {!matchData && !errorMessage && (
            <div
              className='ui raised segment'
              style={{ paddingTop: '2em', borderTop: '1px solid #f1f2f3' }}
            >
              <div className='ui placeholder'>
                <div className='header'>
                  <div className='line' />
                  <div className='line' />
                </div>
                <div className='paragraph'>
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                </div>
                <div className='paragraph'>
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                </div>
                <div className='paragraph'>
                  <div className='line' />
                  <div className='line' />
                  <div className='line' />
                </div>
              </div>
            </div>
          )}
        </div>

        {matchData && ranking.length > 0 && (
          <div className='' style={{ marginTop: '4em' }}>
            <h4 className='ui header'>
              <div className='sub header'>Aktuelle Rangliste</div>
              {matchData.association_name} - {matchData.match_league_name}
            </h4>
            <div className='ui raised segment'>
              <RankingTable data={ranking} />
            </div>
          </div>
        )}

        <div className='ui container'>
          <div className='ui vertical segment'>
            <Suspense fallback={config.searchFallback}>
              <ClubSearch
                label={t.searchLabel}
                onSelectionHandler={handleClubSelection}
              />
            </Suspense>

            <div className='teams-link'>
              <Link to='/all-teams'>
                Zur Liste aller Teams <i className='ui icon chevron right' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
